if (typeof G == 'undefined') G = {};
G.Animations = G.Animations || {};

G.Animations.getGameplayChestOpenAnimation = function getGameplayChestOpenAnimation() {
  var onComplete = new Phaser.Signal();
  return { animate: animate, onComplete: onComplete };

  function animate(game, target) {
    var base = G.Utils.find1stObjectWithName(target, "base");
    var cover = G.Utils.find1stObjectWithName(target, "cover");
    var light = G.Utils.find1stObjectWithName(target, "light");

    target.alpha = 1;
    game.add.tween(target)
      .to({y: target.y - 30}, 1500, Phaser.Easing.Sinusoidal.Out, true);
    game.add.tween(target.scale)
      .to({x: 1.2, y: 1.2}, 400, Phaser.Easing.Sinusoidal.Out, true);

    game.add.tween(target)
      .to({alpha: 0}, 300, Phaser.Easing.Sinusoidal.Out, true, 1200)
      .onComplete.add(function() {
        onComplete.dispatch();
      });

    if (base) {
      base.changeTexture("chest_bottom");
    }

    if (cover) {
      var coverFrameIndex = 0;
      cover.changeTexture("chest_top_00");
      var tween = game.add.tween(cover)
        .to(null, 50, Phaser.Easing.Sinusoidal.In, false, 0, 3);
      tween.onRepeat.add(function() {
        coverFrameIndex++;
        cover.changeTexture("chest_top_0"+coverFrameIndex);
      });
      tween.start();
    } 

    if (light) {
      light.angle = 0;
      light.alpha = 0
      game.add.tween(light)
        .to({angle: -250}, 1500, Phaser.Easing.Linear.None, true);
      game.add.tween(light)
        .to({alpha: 0.3}, 200, Phaser.Easing.Sinusoidal.Out, true)
        .onComplete.add(function() {
          game.add.tween(light)
            .to({alpha: 0}, 200, Phaser.Easing.Sinusoidal.Out, true, 1300);
        });
    }
  }
}
